import { LoadingStatuses } from '@/common/constants';
import { Menu } from 'primereact/menu';
import { MenuItem } from 'primereact/menuitem';
import React, { SyntheticEvent, useRef } from 'react';
import styled from 'styled-components';
import AppButton, { AppButtonProps } from './AppButton';

const SplitButtonGroup = styled.div`
  display: inline-flex;
  align-items: stretch;

  .p-button:first-child {
    position: relative;
    z-index: 1;
    margin-right: -1px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    padding-right: var(--small-padding);
  }

  .p-button:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding-left: var(--xsmall-padding);
    padding-right: var(--medium-padding);
  }
`;

type AppSplitButtonPropsType = {
  items: MenuItem[];
  menuId: string;
  primaryAriaLabel?: string;
  menuAriaLabel: string;
} & AppButtonProps;

const AppSplitButton: React.FC<AppSplitButtonPropsType> = ({
  items,
  menuId,
  primaryAriaLabel,
  menuAriaLabel,
  onClick,
  state = LoadingStatuses.IDLE,
  isDisabled,
  ...rest
}) => {
  const menuRef = useRef<Menu>(null);
  const isBusy = state !== LoadingStatuses.IDLE;

  return (
    <>
      <Menu
        id={menuId}
        model={items}
        popup
        ref={menuRef}
        style={{ width: 'auto', minWidth: '196px' }}
      />

      <SplitButtonGroup>
        <AppButton
          {...rest}
          state={state}
          isDisabled={isDisabled}
          ariaLabel={primaryAriaLabel}
          onClick={onClick}
        />
        <AppButton
          {...rest}
          label={undefined}
          icon="pi pi-chevron-down"
          isDisabled={isDisabled || isBusy}
          ariaLabel={menuAriaLabel}
          onClick={(event: SyntheticEvent<HTMLButtonElement>) =>
            menuRef.current?.toggle(event)
          }
        />
      </SplitButtonGroup>
    </>
  );
};

export default AppSplitButton;
